import { render, staticRenderFns } from "./unpay.vue?vue&type=template&id=35166427&scoped=true&"
import script from "./unpay.vue?vue&type=script&lang=js&"
export * from "./unpay.vue?vue&type=script&lang=js&"
import style0 from "./unpay.vue?vue&type=style&index=0&id=35166427&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35166427",
  null
  
)

export default component.exports